<template>
  <div>
    <div class="flex flex-row mb-5">
      <div class="w-8/12">
        <h2 class="font-bold text-lg">Photo Uploader</h2>
      </div>
      <div class="w-2/12 mr-2">
        <el-select
          v-model="select_existing_album"
          @change="handleExistingAlbum"
          placeholder="Today's Albums"
        >
          <el-option
            v-for="album in albums"
            :key="album.id"
            :label="album.name"
            :value="album.id"
          ></el-option>
        </el-select>
      </div>
      <div class="w-2/12">
        <base-button-success @click="newAlbum" icon="plus">
          New Album
        </base-button-success>
      </div>
    </div>
    <div
      v-for="queue in queues"
      :key="queue.id"
      class="mt-8 py-3 border-b-2 border-gray-400"
    >
      <queue
        :queue-obj="queue"
        @updateAlbum="handleUpdateAlbum"
        @removeQueue="handleRemoveQueue"
        @createDisplayGroup="handleCreateDisplayGroup"
      ></queue>
    </div>
    <album
      :original-album="album"
      :show-modal="showModal"
      @close="showModal = false"
      @save="handleAlbumSave"
    />
  </div>
</template>

<script>
import Queue from "@/components/photographer/Queue";
import Album from "./Album";

export default {
  name: "Uploader",
  components: { Album, Queue },
  data() {
    return {
      showModal: false,
      reevaluate: true,
      album: {
        id: null,
        date: null,
        time_of_day: null,
        river_section_id: null,
        outfitter_id: null,
        photographer_id: null,
        name: null,
      },
      select_existing_album: null,
    };
  },
  methods: {
    handleUpdateAlbum(album) {
      this.album = album;
      this.showModal = true;
    },
    handleAlbumSave(newAlbum) {
      this.showModal = false;
      this.$store.dispatch("queue/add_queue", newAlbum);
      this.$store.dispatch("queue/load_albums");
    },
    handleRemoveQueue(queue) {
      this.$store.dispatch("queue/remove_queue", queue);
    },
    handleOutfitterSelect(outfitter) {
      this.riverSections = outfitter.river_sections;
    },
    handleExistingAlbum() {
      if (
        !this.queues.find((queue) => queue.id === this.select_existing_album)
      ) {
        this.$store.dispatch(
          "queue/add_queue",
          this.albums.find((album) => album.id === this.select_existing_album)
        );
      }
    },

    handleCreateDisplayGroup(album) {
      this.$store
        .dispatch("auth/set_outfitter_id", album.outfitter_id)
        .then((oid) => {
          this.$store.dispatch("outfitter/reload_outfitter", oid);
          const route = this.$router.resolve({
            path: "/dashboard/display-groups",
            query: {
              date: album.date,
              albumId: String(album.id),
              createNew: "true",
            },
          });
          window.open(route.href, "_blank");
        });
    },
    newAlbum() {
      this.album.id = null;
      this.showModal = true;
      const user = this.$store.getters["auth/getUser"];
      if (user.outfitter_id) {
        this.album.outfitter_id = user.outfitter_id;
      }
    },
  },
  computed: {
    queues: function () {
      this.reevaluate;
      return this.$store.getters["queue/getQueues"];
    },

    albums: function () {
      return this.$store.getters["queue/getAlbums"];
    },
  },
  mounted() {
    this.$store.dispatch("outfitter/all", { withDeleted: 0 });

    this.$store.dispatch("riverSection/all", { withDeleted: 0 });
    this.$store.dispatch("photographer/all");

    let albumId = this.$route.params.albumId;
    if (!albumId) {
      this.$store.dispatch("queue/load_albums");
    } else {
      this.$store.dispatch("queue/load_album", albumId).then((resp) => {
        this.$store.dispatch("queue/add_queue", resp.album);
      });
    }
  },
};
</script>
<style scoped>
::v-deep .el-select .el-input__inner::placeholder {
  color: #000000;
  font-weight: bold;
}
</style>
